<template>
  <div class="errors">
    404
  </div>
</template>

<script>
/**
 * @description 错误页面
 * @created 2024/04/19 17:36:37
 */
export default {
  meta: {
    title: ""
  },
  name: "Errors",
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.errors {
  height: 100%;
  @include flex();
}
</style>
